import api from "./api";
import { parsePaginatedList, PaginatedApiPayload } from "../utils/pagination";

export interface AuditLogEntry {
  id: string;
  userId: string | null;
  userEmail: string | null;
  userRole: string | null;
  action: string;
  resource: string;
  resourceId: string | null;
  httpMethod: string;
  path: string;
  requestBody: Record<string, unknown> | null;
  responseStatus: number | null;
  success: boolean;
  errorMessage: string | null;
  ipAddress: string | null;
  userAgent: string | null;
  createdAt: string;
  user?: {
    id: string;
    name: string;
    email: string;
    role: string;
    phone?: string;
    isActive?: boolean;
    branchId?: string;
    salesPointId?: string;
    branch?: { id: string; name: string; address?: string };
    salesPoint?: { id: string; name: string };
  } | null;
}

export type AuditLogSortField =
  | "createdAt"
  | "userEmail"
  | "userRole"
  | "action"
  | "resource"
  | "httpMethod"
  | "path"
  | "success"
  | "userName";

export type AuditLogSortOrder = "ASC" | "DESC";

export interface AuditLogFilter {
  pageNo?: number;
  pageSize?: number;
  userId?: string;
  resource?: string;
  action?: string;
  success?: boolean | "all";
  search?: string;
  startDate?: string;
  endDate?: string;
  sortBy?: AuditLogSortField;
  sortOrder?: AuditLogSortOrder;
}

export const auditLogsAPI = {
  async getAuditLogs(filters: AuditLogFilter = {}) {
    const params: Record<string, string | number | boolean> = {};
    if (filters.pageNo != null) params.pageNo = filters.pageNo;
    if (filters.pageSize != null) params.pageSize = filters.pageSize;
    if (filters.userId) params.userId = filters.userId;
    if (filters.resource && filters.resource !== "all") {
      params.resource = filters.resource;
    }
    if (filters.action && filters.action !== "all") params.action = filters.action;
    if (filters.success !== undefined && filters.success !== "all") {
      params.success = filters.success;
    }
    if (filters.search) params.search = filters.search;
    if (filters.startDate) params.startDate = filters.startDate;
    if (filters.endDate) params.endDate = filters.endDate;
    if (filters.sortBy) params.sortBy = filters.sortBy;
    if (filters.sortOrder) params.sortOrder = filters.sortOrder;

    const response = await api.get("/audit-logs", { params });
    const parsed = parsePaginatedList<AuditLogEntry>(
      response.data?.data as PaginatedApiPayload<AuditLogEntry>
    );
    return parsed;
  },

  async getAuditLogById(id: string): Promise<AuditLogEntry> {
    const response = await api.get(`/audit-logs/${id}`);
    return response.data.data;
  },
};
